import styled, { css } from "styled-components";
import { theme } from "../../../constants/StyledComponents";
import { IconSizeEnum } from "../../../types/AppTypes";
import { MouseEventHandler } from "react";

type StyledIconManagerProps = {
  $size?: IconSizeEnum;
  $color?: string;
  $marginRight?: number;
  $fill?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  $noStrokeColor?: boolean;
};

const sizes = (size = IconSizeEnum.SMALL) =>
  ({
    xsmall: css`
      width: ${theme.variables.height_7};
      height: ${theme.variables.height_7};
    `,
    small: css`
      width: ${theme.variables.height_5};
      height: ${theme.variables.height_5};
    `,
    medium: css`
      width: ${theme.variables.height_6};
      height: ${theme.variables.height_6};
    `,
    large: css`
      width: ${theme.variables.height_1};
      height: ${theme.variables.height_1};
    `,
  })[size];

const strokeWidth = (size = IconSizeEnum.SMALL) =>
  ({
    xsmall: theme.variables.sw_1,
    small: theme.variables.sw_3,
    medium: theme.variables.sw_3,
    large: theme.variables.sw_4,
  })[size];

const marginVariant = (marginRight: number = 0) => css`
  margin-right: ${marginRight}px;
`;

export const StyledIconManager = styled.div<StyledIconManagerProps>`
  ${({ $size: size }) => sizes(size)};
  ${({ $marginRight }) => marginVariant($marginRight)};
  cursor: ${(props) => (props.onClick ? "pointer" : "inherit")};

  & svg {
    stroke: ${({ $color, disabled, $noStrokeColor }) => {
      if ($noStrokeColor) return "unset";

      return disabled
        ? theme.colors.grey_4
        : $color
          ? $color
          : theme.colors.black;
    }};
    fill: ${({ $fill: fill }) => fill ?? theme.colors.trasparent};
    ${({ $size: size }) => sizes(size)};
  }
  & svg path {
    stroke-width: ${({ $size: size }) => strokeWidth(size)};
  }
`;
